import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
// Services
import PercentileService from '@/core/services/percentile.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class TablePercentileComponent extends Vue {

  // Service's Instance
  percentileService: any = new PercentileService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  searchFlag: any = [];
  percentileList: any = [];
  allScores: any = [];
  allScoresTwo: any = [];
  allScoresThree: any = [];
  allScoresFour: any = [];
  search: string = "";


  mounted (){
    const _ = this;
    _.get();
    _.filterDate();
  }

  filterDate(date: any = ''){
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  get(){
    const _ = this;
    _.isLoading = false;
    _.percentileService.get().then((data: any) => {
      console.log(data);
      _.percentileList = data['data'].skills;
      _.allScores = data['data'].skills;
      for(let i = 0; i < _.allScores.length; i++){
        console.log(_.allScores[i].scores);
      }
      _.allScoresTwo = data['data'].skills[1].scores;
      _.allScoresThree = data['data'].skills[2].scores;
      _.allScoresFour = data['data'].skills[3].scores;
      setTimeout(() => {
        _.isLoading = false;
      }, 2000)
    })

    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 2000)
    })
  }

  delete_survey(idSurvey){
    const _ = this;
    _.isLoading = true;
    _.surveyService.delete_survey(idSurvey).then((data: any) => {
      _.get();
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 2000)
    })
  }

}
